<template>
  <block>
    <div class="modal" v-if="isFaqShow">
      <div class="modal_contain">
        <div class="title_top">
          <div></div>
          <div class="modal_title">常见问题</div>
          <div class="modal_close" @click="closeFaq"></div>
        </div>
        <div v-html="faq" class="modal_faq"></div>
      </div>
    </div>
    <div class="modal" v-if="isTrialShow">
      <div class="modal_trial_box">
        <div class="modal_contain_trail">
          <div class="img"></div>
          <div class="title">恭喜你</div>
          <div class="desc">星耀直通卡领取成功，请稍后试试吧～</div>
          <div class="btn" @click="closeTrial"></div>
        </div>
        <div @click="closeTrial" class="modal_trial_close"></div>
      </div>
    </div>
    <div :class="`member ${activeTab === 30 ? 'senior' : 'basic'}`">
      <common-title titleName="会员中心" v-if="!isHideTitle" :isAPPShow="true" />
      <div class="member__top" v-if="!(isMini)"></div>
      <div
        v-if="[0, 10, 40, 50, 60].includes(userMemberInfo.level)"
        :class="`member__tab ${activeTab === 30 ? 'senior' : 'basic'}`"
      >
        <div @click="setTabActive(20)" class="member__tab-item member__tab-basic">
          <span class="icon"></span>
          <span class="member__tab_title">星耀直通卡</span>
        </div>
        <div @click="setTabActive(30)" class="member__tab-item member__tab-senior">
          <span class="icon"></span>
          <span class="member__tab_title">研力特权卡</span>
        </div>
      </div>
      <div
        :class="`member__contain ${activeTab === 30 ? 'member__contain-senior' : 'member__contain-basic'}`"
      >
        <user-card
          :activeTab="activeTab"
          :userMemberInfo="userMemberInfo"
          :userInfo="userInfo"
          :openChat="openChat"
          :generateOrder="generateOrder"
          :showTrialBtn="showTrialBtn"
          :showBasicBtn="showBasicBtn"
          :showSeniorBtn="showSeniorBtn"
          :benefits="activeTab === 30 ? seniorBenefits : basicBenefits"
          :number="this.memberLevelInfo[activeTab].number"
          :showFaq="showFaq"
        ></user-card>
        <div
          class="tools"
          v-if="(activeTab === 20 && showBasicBtn === 1) || (activeTab === 30 && showBasicBtn === 1)"
        >
          <div class="member__empty"></div>
          <div class="member__empty-desc">权益版块即将开放</div>
        </div>
        <div
          v-else
          :class="`tools ${[0, 10, 40, 50, 60].includes(userMemberInfo.level) ? 'toolBottom' : ''}`"
        >
          <study-tools
            :activeTab="activeTab"
            :userMemberInfo="userMemberInfo"
            :userInfo="userInfo"
          />
          <question-bank />
          <study-video
            :activeTab="activeTab"
            :userMemberInfo="userMemberInfo"
            :userInfo="userInfo"
            :productId="politics"
          />
          <weekly :userMemberInfo="userMemberInfo" :weeklyInfo="weeklyInfo" />
          <study-server
            v-if="activeTab === 30"
            :activeTab="30"
            :userMemberInfo="userMemberInfo"
            :userInfo="userInfo"
            :productId="server"
            :showDownAppModal="showDownAppModal"
          />
          <course
            v-show="activeTab === 30"
            :activeTab="30"
            :userInfo="userInfo"
            :userMemberInfo="userMemberInfo"
            :productIds="course.slice() || []"
          />
          <coupons
            :activeTab="activeTab"
            v-if="couponIds.length"
            :userInfo="userInfo"
            :userMemberInfo="userMemberInfo"
            :couponIds="couponIds"
          />
          <buy-btn
            v-if="![20, 30].includes(userMemberInfo.level) && !(userMemberInfo.level === 30 && activeTab === 30)"
            :userMemberInfo="userMemberInfo"
            :userInfo="userInfo"
            :activeTab="activeTab"
            :memberLevelInfo="memberLevelInfo"
            :generateOrder="generateOrder"
            :openChat="openChat"
            :showSeniorBtn="showSeniorBtn"
            :showBasicBtn="showBasicBtn"
          />
          <down-load-app :closeDownAppModal="onCloseDownAppModal" v-if="isDownAppModalShow" />
        </div>
      </div>
    </div>
    <!-- v-if="userMemberInfo.level === 20 || userMemberInfo.level === 30 " -->
    <div
      class="member_shequn_two_code_box"
      v-if="[10, 20, 30, 40, 50, 60].includes(userMemberInfo.level)"
    >
      <div class="member_shequn_two_code">
        <div class="text" @click="openCodeModal">加入会员群</div>
      </div>
    </div>
    <DisplayTwoCode v-if="isDisplayCode" :closeCodeModal="closeCodeModal" />
  </block>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  getUserMember,
  getMemberLevelInfo,
  reqCombinationlist,
  reqCombinationDetail,
  reqSubOrder,
  getBasicBenefits,
  getSeniorBenefits,
  getMemberDetail,
  getWeekly,
  getClassType,
} from '@/api/member/index';
import wx from 'weixin-js-sdk';

import UserCard from './components/UserCard/index.vue';
import StudyTools from './components/StudyTools/index.vue';
import QuestionBank from './components/QuestionBank/index.vue';
import StudyVideo from './components/StudyVideo/index.vue';
import Weekly from './components/Weekly/index.vue';
import StudyServer from './components/StudyServer/index.vue';
import Course from './components/Courses/index.vue';
import Coupons from './components/Coupons/index.vue';
import BuyBtn from './components/BuyBtn/index.vue';
import DownLoadApp from './components/DownLoadApp/index.vue';
import DisplayTwoCode from './components/memberTwoCode/index.vue';
// eslint-disable-next-line import/extensions

export default {
  components: {
    UserCard,
    StudyTools,
    QuestionBank,
    StudyVideo,
    Weekly,
    StudyServer,
    Course,
    Coupons,
    BuyBtn,
    DownLoadApp,
    DisplayTwoCode,
  },
  data() {
    return {
      ceshi1: 1,
      gioVisitUserId: '',
      activeTab: 20, // 20 基础会员 30 高级会员
      // 用户会员等级
      userMemberInfo: {
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员 40 普通会员周卡 50 普通会员半月卡 40 普通会员月卡
        levelName: '普通用户',
        deadlineStartTime: null,
        deadlineEndTime: null, // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      },
      memberLevelInfo: {
        10: {
          number: 0,
          packageId: null, // 套餐ID
          products: null, // 套餐内产品
          priceInfo: {}, // 相关价格
          productIds: [], // 套餐下面的priductId
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 试用会员
        20: {
          number: 0,
          packageId: null,
          products: null,
          priceInfo: {},
          productIds: [],
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 普通会员
        30: {
          number: 0,
          packageId: null,
          products: null,
          priceInfo: {},
          productIds: [],
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 高级会员
        40: {
          number: 0,
          packageId: null,
          products: null,
          priceInfo: {},
          productIds: [],
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 普通会员
        50: {
          number: 0,
          packageId: null,
          products: null,
          priceInfo: {},
          productIds: [],
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 普通会员
        60: {
          number: 0,
          packageId: null,
          products: null,
          priceInfo: {},
          productIds: [],
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 普通会员
      },
      memberLevelInfoTemp: null,
      showTrialBtn: false,
      showBasicBtn: 0,
      showSeniorBtn: 0,
      isApp: this.$root.$data.isApp || false,
      isMini: this.$root.miniprogram || false,
      basicBenefits: [],
      seniorBenefits: [],
      faq: '',
      isFaqShow: false,
      isTrialShow: false,
      isDownAppModalShow: false,
      weeklyInfo: null,
      politics: '', // 当前绑定的时政
      server: '', // 当前绑定的服务
      course: '', // 当前绑定的课程
      couponIds: '', // 当前绑定的优惠券
      isDisplayCode: false, // 是否展示加入社群二维码
      isHideTitle: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.isHideTitle = this.$route.query.isHideTitle || false;
    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = value => {
      this.getAndroid(value);
    };
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
  },
  methods: {
    // mode不要删除 不然会报错
    async init(mode) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      this.memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfo));
      // 获取会员等级相关信息
      const MemberLevelInfo = await getMemberLevelInfo();
      const packageIdToMemberLevel = {};
      const btnMap = {
        10: 'showTrialBtn',
        20: 'showBasicBtn',
        30: 'showSeniorBtn',
        40: 'showBasicBtn',
        50: 'showBasicBtn',
        60: 'showBasicBtn',
      };
      let showBasicBtn = 1;
      let showSeniorBtn = 1;
      const allProductIds =
        MemberLevelInfo?.map(item => {
          this.memberLevelInfoTemp[item.memberLevel] = {
            packageId: item.packageId,
            number: item.number,
          };
          switch (item.memberLevel) {
            case 10:
              this[btnMap[item.memberLevel]] = true;
              break;
            case 20:
              showBasicBtn = 2;
              break;
            default:
              showSeniorBtn = 2;
          }
          packageIdToMemberLevel[item.packageId] = item.memberLevel;
          return item.packageId;
        }) || [];
      this.showBasicBtn = showBasicBtn;
      this.showSeniorBtn = showSeniorBtn;
      // 获取展示的产品ID配置
      const memberDetail = await getMemberDetail();
      memberDetail.forEach(item => {
        const { code, remark } = item;
        const { politics, allPolitics, server, allServer } = JSON.parse(remark);
        this.memberLevelInfoTemp[code] = {
          ...this.memberLevelInfoTemp[code],
          politics,
          allPolitics,
          server,
          allServer,
        };
      });
      // this.memberLevelInfo = memberLevelInfoTemp;
      await this.setPriceInfo(allProductIds, packageIdToMemberLevel);
      await this.setProductInfo(packageIdToMemberLevel);
      // 获取基础权益配置
      await this.reqBasicBenefits();
      // 获得高级权益配置
      await this.reqSeniorBenefits();
      console.log('this.memberLevelInfo', this.memberLevelInfo);
      this.memberLevelInfo = this.memberLevelInfoTemp;
      // 获取当前用户会员信息
      if (this.userInfo.id) {
        const userMemberInfoTemp = await getUserMember();
        const { deadlineEndTime, level, productIds, ...rest } = userMemberInfoTemp;
        this.userMemberInfo = {
          ...rest,
          level,
          productIds,
          deadlineEndTime: deadlineEndTime?.split(' ')[0] || '',
        };
        const activeTabTemp = this.$route.query.activeTab;
        if (level === 0) {
          if (activeTabTemp === '30') {
            this.activeTab = 30;
            this.setIds(30);
          } else {
            this.activeTab = 20;
            this.setIds(20);
          }
        } else {
          if ([10, 40, 50, 60].includes(level)) {
            if (activeTabTemp === '30') {
              this.activeTab = 30;
            } else {
              this.activeTab = 20;
            }
          } else {
            this.activeTab = level;
          }
          const { allPolitics, allServer, coupons } = this.memberLevelInfoTemp[
            this.activeTab === 30 ? '30' : '20'
          ];
          const productIdsArr = productIds.split(',').map(String);
          const server =
            productIdsArr.filter(v =>
              allServer
                .split(',')
                .map(String)
                .includes(v),
            )[0] || '';
          this.server = server;
          const politics =
            productIdsArr.filter(v =>
              allPolitics
                .split(',')
                .map(String)
                .includes(v),
            )[0] || '';
          this.politics = politics;
          this.course = productIdsArr.filter(item => item !== server && item !== politics);
          this.couponIds = coupons.split(',').map(String);
        }

        if (level !== 0) {
          this.setWeeklyInfo();
        }
      } else {
        const activeTabTemp = this.$route.query.activeTab;
        if (activeTabTemp === '30') {
          this.activeTab = 30;
          this.setIds(30);
        } else {
          this.activeTab = 20;
          this.setIds(20);
        }
      }
      this.$toast.clear();
    },
    openCodeModal() {
      this.isDisplayCode = true;
    },
    closeCodeModal() {
      this.isDisplayCode = false;
    },
    showDownAppModal() {
      this.isDownAppModalShow = true;
    },
    onCloseDownAppModal() {
      this.isDownAppModalShow = false;
    },
    // 获取基础权益
    async reqBasicBenefits() {
      const data = await getBasicBenefits();
      this.basicBenefits = data.map(item => {
        const { remark } = item;
        const { title, icon } = JSON.parse(remark);
        return { title, icon };
      });
    },
    // 获取高级权益
    async reqSeniorBenefits() {
      const data = await getSeniorBenefits();
      this.seniorBenefits = data.map(item => {
        const { remark } = item;
        const { title, icon } = JSON.parse(remark);
        return { title, icon };
      });
    },
    // 切换会员tab
    setTabActive(key) {
      this.activeTab = key;
      this.setIds(key);
    },
    async setWeeklyInfo() {
      const res = await getWeekly();
      if (res.code === 0) {
        this.weeklyInfo = res.data;
      }
    },
    setIds(key) {
      const { server, politics, allPolitics, coupons } = this.memberLevelInfo[key];
      this.server = server;
      const { level, productIds } = this.userMemberInfo;
      if ([10, 40, 50, 60].includes(level)) {
        const productIdsArr = productIds.split(',').map(String);
        this.politics =
          productIdsArr.filter(v =>
            allPolitics
              .split(',')
              .map(String)
              .includes(v),
          )[0] || '';
      } else {
        this.politics = politics;
      }
      this.course = this.memberLevelInfo[key].productIds
        .map(String)
        .filter(item => !!(item !== server && item !== politics));
      this.couponIds = coupons.split(',').map(String);
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId ||
          ''}',wechatSource:'${this.miniParams()}'}`;
      }
    },
    // 获取价格信息
    async setPriceInfo(allProductIds, packageIdToMemberLevel) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfoTemp));
      const data = await reqCombinationlist(endPoint, allProductIds);
      data.forEach(item => {
        const { packageDiscountRespVO, originalPrice, sellPrice, packageId } = item;
        const { payPrice, promotionLabel, promotionEndTime } = packageDiscountRespVO;
        const priceInfo = {
          price: promotionLabel ? payPrice : sellPrice,
          originalPrice: promotionLabel ? sellPrice : originalPrice,
          endTime: promotionEndTime,
        };
        memberLevelInfoTemp[packageIdToMemberLevel[packageId]].priceInfo = priceInfo;
      });
      this.memberLevelInfoTemp = memberLevelInfoTemp;
    },
    // 获取产品详情
    async setProductInfo(packageIdToMemberLevel) {
      const promises = Object.keys(packageIdToMemberLevel).map(reqCombinationDetail);
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfoTemp));
      let classType = '';
      const responses = await Promise.all(promises);
      responses.forEach(data => {
        const {
          packageId,
          packageProductRespList,
          faq,
          packageAttributeVOList,
          memberServiceConfigDetail,
        } = data;
        const orderDetailArr = packageProductRespList.map(subItem => {
          const { packageProductSkuWebRespList, productId } = subItem;
          const { skuId } = packageProductSkuWebRespList[0];
          const { dataJson } = packageAttributeVOList[0];
          classType = dataJson;
          return {
            productId,
            skuId,
            packageId,
          };
        });
        memberLevelInfoTemp[packageIdToMemberLevel[packageId]].products = orderDetailArr;
        memberLevelInfoTemp[packageIdToMemberLevel[packageId]].faq = faq;
        memberLevelInfoTemp[packageIdToMemberLevel[packageId]].productIds = orderDetailArr.map(
          item => item.productId,
        );
        memberLevelInfoTemp[packageIdToMemberLevel[packageId]].coupons =
          memberServiceConfigDetail?.couponDetailList?.map(item => item.couponId).join(',') || '';
      });
      if (this.$root.miniprogram) {
        const types = await getClassType();
        const status = types.some(item => item.value === classType);
        this.$root.setMiniProgramBuy(status);
      }
      this.memberLevelInfoTemp = memberLevelInfoTemp;
    },
    // 生成订单
    generateOrder(level) {
      if (!this.userInfo.id) {
        this.commonLogin();
      } else {
        switch (level) {
          case 0:
            break;
          case 10:
            this.receiveTrialMember();
            break;
          default:
            this.entryPayOrder(level);
        }
      }
    },
    commonLogin() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          if (params) {
            const paramsMap = new Map();
            params.forEach(item => {
              const [key, value] = item.split('=');
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of entries) {
              if (ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
          }
        }
        const redirctUrl = encodeURIComponent(
          `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
      }
    },
    // 领取试用会员
    async receiveTrialMember() {
      let referer = '';
      if (sessionStorage.getItem('fromPageUrl')) {
        const paramData = JSON.parse(sessionStorage.getItem('fromPageUrl'));
        referer = paramData.fromPageUrl ? paramData.fromPageUrl : paramData.fromPageUrlLast;
      }
      // eslint-disable-next-line
      let uuid = gio('getVisitUserId') || [];
      // eslint-disable-next-line
      if (!this.isApp) {
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${this.$route.query.liveRoomId ||
          ''}',wechatSource:'会员中心'}`;
      }
      const { packageId, products } = this.memberLevelInfo[10];
      const subData = {
        // 订单提交请求对象
        channelMark: 5, // 下单渠道 ：5学员端下单
        products: products.map(item => ({
          productId: item.productId,
          productSkuId: item.skuId,
          quantity: 1, // 产品数量
          type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
          packageId,
        })),
        terminalMark: this.$global.terminalMark,
        orderReferer: referer,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
        extendParam: this.gioVisitUserId,
        orderSource: '会员中心',
      };
      const { data, code } = await reqSubOrder(subData);
      if (code !== 0 || Number(data.payAmount) !== 0) {
        this.$toast('未领取成功，请联系客服处理~');
      } else {
        this.isTrialShow = true;
        this.showTrialBtn = false;
        if (this.isApp) {
          this.$sendToApp('onFreeCourseSuccess', { type: 1, level: 10 }, false);
        }
      }
    },
    closeTrial() {
      this.isTrialShow = false;
      this.init();
    },
    // 支付订单
    entryPayOrder(level) {
      const info = this.memberLevelInfo[level];
      const { packageId, products } = info;
      if (this.isApp) {
        this.$sendToApp(
          'buyCourseNew',
          {
            product: JSON.stringify(products),
            packageId,
            miniBeforePageName: 8,
            level,
          },
          false,
        );
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        const { origin } = window.location;
        let path = `${origin}/ark/payOrder?product=${JSON.stringify(
          products,
        )}&packageId=${packageId}&miniBeforePageName=8&`;
        const params = searchParams.split('&');
        if (params) {
          const paramsMap = new Map();
          params.forEach(item => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        const miniBeforePageName = localStorage.getItem('miniBeforePageName');
        if (!miniBeforePageName) {
          localStorage.setItem('miniBeforePageName', 8);
        }
        this.$router.push({
          path: '/payOrder',
          query: {
            product: JSON.stringify(products),
            packageId,
          },
        });
      }
    },
    openChat() {
      if (this.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `https://iqihang.sobot.com/chat/h5/v7/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this
              .userInfo.id || ''}`,
          },
          false,
        );
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: '/subPackages/zhichi/zhichi',
        });
      } else {
        window.open(
          `https://iqihang.sobot.com/chat/h5/v7/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this
            .userInfo.id || ''}`,
        );
      }
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.init();
    },
    showFaq(key) {
      const { faq } = this.memberLevelInfo[key];
      this.faq = faq;
      this.isFaqShow = true;
    },
    closeFaq() {
      this.faq = '';
      this.isFaqShow = false;
    },
    preDefaulut(flag) {
      if (flag) {
        document.body.style.overflow = 'hidden';
        // document.addEventListener('touchmove', preD, { passive: false }); // 禁止页面滑动
      } else {
        document.body.style.overflow = ''; // 出现滚动条
        // document.removeEventListener('touchmove', preD, { passive: false });
      }
    },
  },
  watch: {
    isFaqShow(flag) {
      this.preDefaulut(flag);
    },
    isTrialShow(flag) {
      this.preDefaulut(flag);
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';

.member {
  width: 750px;
  min-height: 100vh;
  background: rgba(247, 248, 252, 1);

  &__top {
    height: 100px;
  }

  &__tab {
    @include background(100%, 90px);

    display: flex;

    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      height: 100%;

      .icon {
        @include background(43px, 43px);

        margin-right: 14px;
      }
    }

    &-basic .icon {
      @include backgroundImage('tab_basic_icon.png');
    }

    &-senior .icon {
      @include backgroundImage('tab_basic_senior1.png');
    }

    &.basic {
      @include backgroundImage('tab_basic.png');
    }

    &.senior {
      @include backgroundImage('tab_senior.png');
    }

    &_title {
      color: #ffe2c4;
      font-weight: 500;
      font-size: 31px;
      font-family: PingFangSC, PingFang SC, sans-serif;
    }
  }

  &__contain {
    padding-top: 36px;
    background: rgba(247, 248, 252, 1);

    &-basic {
      background: #9c6a3e;
    }

    &-senior {
      background: #100f17;
    }
  }

  .tools {
    width: 750px;
    margin-top: -94px;
    padding-top: 140px;
    padding-bottom: 62px;
    background: #f7f8fc;
    border-radius: 36px 36px 0 0;

    .member__empty {
      @include background(308px, 219px);
      @include backgroundImage('member_empty.png');

      margin: 100px auto 13px;

      &-desc {
        color: #999;
        font-weight: 400;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 36px;
        text-align: center;
      }
    }
  }

  .toolBottom {
    padding-bottom: 170px;
  }
}

.btn {
  width: 350px;
  height: 71px;
  margin: 0 auto 40px;
  color: #fff;
  font-weight: 500;
  font-size: 29px;
  line-height: 71px;
  text-align: center;
  background: linear-gradient(270deg, #ff6c02 0%, #ff7f41 100%);
  border-radius: 35px;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 110;
  background-color: rgba(0, 0, 0, 0.7);

  .modal_contain {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 634px;
    padding: 31px 33px 58px;
    background: #fff;
    border-radius: 14px;
    transform: translate(-50%, -50%);

    .title_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
    }

    .modal_title {
      color: #333;
      font-weight: 500;
      font-size: 29px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 40px;
    }

    .modal_close {
      @include background(29px, 29px);
      @include backgroundImage('member_close.png');
    }

    .modal_faq {
      max-height: 600px;
      margin-top: 72px;
      overflow-y: scroll;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 43px;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
  }

  .modal_trial_box {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translate(-50%, -50%);

    .modal_contain_trail {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 649px;
      height: 641px;
      background-color: #fff;
      border-radius: 54px;

      .img {
        @include background(649px, 228px);
        @include backgroundImage('member_trail_bg.png');
      }

      .title {
        margin-top: 72px;
        color: #ff7d3c;
        font-weight: 600;
        font-size: 40px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 54px;
      }

      .desc {
        margin: 29px 0 58px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 36px;
      }

      .btn {
        @include background(333px, 91px);
        @include backgroundImage('member_trail_confirm.png');
      }
    }

    .modal_trial_close {
      margin-top: 51px;
      @include background(69px, 69px);
      @include backgroundImage('member_trial_close.png');
    }
  }
}
</style>
